import { toast } from 'react-toastify';

export default (msg)=>{
    toast(msg, {hideProgressBar: true});
}